import styled from '@emotion/styled';

import { forDesktop, forMobile } from '@/design-system';

export const ChartCard = styled('section')(({ theme }) => ({
  overflow: 'hidden',
  border: `1px solid ${theme.colors.border.default}`,
  borderRadius: theme.radius[16],
}));

export const ChartHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: theme.spacing[16],
  padding: theme.spacing[24],

  [forMobile]: { padding: theme.spacing[16] },
}));

export const Plot = styled('div')({
  height: 250,
  [forDesktop]: { height: 143 },
});

export const PlotPlaceholder = styled('div')({
  display: 'flex',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
});

export const BalanceBlock = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],

  [forDesktop]: { gap: 0 },
}));

export const BalanceRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  flexWrap: 'wrap',
}));

export const BalanceValue = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  minWidth: 0,
  fontVariantNumeric: 'tabular-nums',
});
